import { useState } from "react"
import { useMutation, useQuery } from "convex/react"
import { toast } from "sonner"
import { api } from "../../../../convex/_generated/api"
import { errorMessage } from "@/lib/errors"

export function useCandidateVisibility() {
  const profile = useQuery(api.profiles.me)
  const update = useMutation(api.profiles.updateProfile)
  const [pending, setPending] = useState(false)

  const role = profile?.role
  const openToHiring = profile?.candidateVisibility === "discoverable"
  const deletionRequested = Boolean(profile?.deletionRequestedAt)

  const setOpenToHiring = async (next: boolean) => {
    if (role !== "seeker" || pending) return
    if (next && deletionRequested) {
      toast.error("Cancel the deletion request before enabling discovery")
      return
    }
    setPending(true)
    try {
      await update({
        candidateVisibility: next ? "discoverable" : "private",
      })
      toast.success(
        next
          ? "You're open to work — verified companies can discover you"
          : "You're private — hidden from talent search",
      )
    } catch (error) {
      toast.error(
        errorMessage(error, "Could not update hiring status"),
      )
    } finally {
      setPending(false)
    }
  }

  return {
    role,
    openToHiring,
    deletionRequested,
    pending: pending || profile === undefined,
    setOpenToHiring,
  }
}
